<nav aria-label="pagination" class="pagination-container d-flex flex-row align-items-center p-0 justify-content-between">

    <div class="pagination-count d-flex align-items-center">
        <span class="me-1">Total Records: </span>
        <span class="fw-bold">{{ totalItems }}</span>
    </div>

    <div class="pagination-buttons d-flex align-items-center">
        <ul class="p-0 m-0 d-flex align-items-center list-unstyled gap-2">
            <li>
                <button aria-label="Go To First Page"
                        [attr.data-identifier]="firstPageIdentifier"
                        [attr.aria-disabled]="currentPage === 1"
                        [disabled]="currentPage === 1"
                        (click)="onFirst()">
                    <i class="fa fa-angle-double-left fs-5"></i>
                </button>
            </li>
            <li>
                <button aria-label="Go To Previous Page"
                        [attr.data-identifier]="previousPageIdentifier"
                        [attr.aria-disabled]="currentPage === 1"
                        [disabled]="currentPage === 1"
                        (click)="onPrevious()">
                    <i class="fa fa-angle-left fs-5"></i>
                </button>
            </li>
            <li *ngFor="let page of pages;">
                <a role="button"
                   [attr.data-identifier]="currentPageIdentifier"
                   tabindex="{{ page === -1 ? '-1' : '0' }}"
                   [attr.aria-current]="page === currentPage ? 'page' : null"
                   [attr.aria-label]="page === currentPage ? 'Current Page, Page ' + page : 'Go to Page ' + page"
                   [style.pointer-events]="page === -1 ? 'none' : 'auto'"
                   [class.current]="page === currentPage"
                   (click)="onGoTo(page)"
                   (keyup.enter)="onGoTo(page)">
                    {{ page === -1 ? '...' : page }}
                </a>
            </li>
            <li>
                <button aria-label="Go To Next Page"
                        [attr.data-identifier]="nextPageIdentifier"
                        [attr.aria-disabled]="currentPage === totalPages"
                        [disabled]="currentPage === totalPages"
                        (click)="onNext()">
                    <i class="fa fa-angle-right fs-5"></i>
                </button>
            </li>
            <li>
                <button aria-label="Go To Last Page"
                        [attr.data-identifier]="lastPageIdentifier"
                        [attr.aria-disabled]="currentPage === totalPages"
                        [disabled]="currentPage === totalPages"
                        (click)="onLast()">
                    <i class="fa fa-angle-double-right fs-5"></i>
                </button>
            </li>
        </ul>
    </div>

    <div ngbDropdown class="pagination-size d-flex align-items-center">
        <span class="me-2">View Records By</span>
        <button ngbDropdownToggle class="btn ml-2 p-1 navigation-dropdown">
            {{ itemsPerPage }}
        </button>
        <div ngbDropdownMenu>
            <button
                *ngFor="let option of itemsPerPageOptions"
                class="dropdown-item"
                [attr.data-identifier]="viewByIdentifier"
                (click)="onSelectItemsPerPage(option)">
                {{ option }}
            </button>
        </div>
    </div>

</nav>
